/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";

@Component
export default class BaseMixin extends Vue {
  paramsToQueryString(params: any, ignoreNull = true): string {
    const queryString: string[] = [];

    for (let key in params) {
      if (Array.isArray(params[key])) {
        for (const value in params[key]) {
          queryString.push(`${key}[]=${params[key][value]}`);
        }
      } else if (typeof params[key] == "object") {
        for (let subkey in params[key]) {
          if (ignoreNull && params[key][subkey] == null) {
            continue;
          }

          queryString.push(
            `${key}[${subkey}]=` + encodeURIComponent(params[key][subkey])
          );
        }
      } else {
        if (ignoreNull && params[key] == null) {
          continue;
        }

        queryString.push(`${key}=` + encodeURIComponent(params[key]));
      }
    }

    return queryString.join("&");
  }

  requestStatus(tag: string) {
    return this.$store.getters["http/status"][tag];
  }
}
